import { createRouter, createWebHistory } from 'vue-router';
import { Auth } from 'aws-amplify';
import store from '../store';

const parseProps = (r) => ({ id: parseInt(r.params.id, 10), returnTo: r.params.returnTo });

function isUserAuthenticated() {
  return new Promise((resolve, reject) => {
    try {
      Auth.currentAuthenticatedUser().then((response) => {
        console.log('response in route guard is: ', response);
        if (response.preferredMFA === 'NOMFA') {
          reject();
        }
        const groups = response.signInUserSession.accessToken.payload['cognito:groups'];
        console.log('The groups I belong to... ', groups);
        if (groups && (groups.includes('billing-admin-power-users') || groups.includes('billing-admin-standard-users') || groups.includes('billing-admin-it-admin'))) {
          resolve();
        } else {
          store.commit('users/setUser', '');
          reject();
        }
      }, (error) => {
        // handle error here
        console.log('error was thrown:', error);
        store.commit('users/setUser', '');
        reject();
      });
    } catch (err) {
      console.log('Error loading user', err);
      store.commit('users/setUser', '');
      reject();
    }
  });
}

function isAdmin() {
  return new Promise((resolve, reject) => {
    try {
      Auth.currentAuthenticatedUser().then((response) => {
        const groups = response.signInUserSession.accessToken.payload['cognito:groups'];
        if (groups && (groups.includes('billing-admin-it-admin'))) {
          resolve();
        } else {
          reject();
        }
      }, (error) => {
        console.log('error was thrown while getting user from cognito:', error);
        reject();
      });
    } catch (err) {
      console.log('Error validating user is admin', err);
      reject();
    }
  });
}

const routes = [
  {
    path: '/',
    name: 'Login',
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next('/exception-report'); }, () => { next(true); });
    },
    component: () => import(/* webpackChunkName: "billing-app" */ '../components/Login.vue'),
  },
  {
    path: '/current-billing',
    name: 'CurrentBilling',
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next(true); }, () => { next('/'); });
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "billing-app" */ '../views/CurrentBilling.vue'),
  },
  {
    path: '/exception-report',
    name: 'ExceptionReport',
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next(true); }, () => { next('/'); });
    },
    component: () => import(/* webpackChunkName: "billing-app" */ '../views/ExceptionReport.vue'),
  },
  {
    path: '/past-billings',
    name: 'PastBillings',
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next(true); }, () => { next('/'); });
    },
    component: () => import(/* webpackChunkName: "billing-app" */ '../views/PastBillings.vue'),
  },
  {
    path: '/customers',
    name: 'CustomerSearch',
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next(true); }, () => { next('/'); });
    },
    component: () => import(/* webpackChunkName: "billing-app" */ '../views/Customers.vue'),
  },
  {
    path: '/customers/:id',
    name: 'customer-detail',
    // props: true,
    props: parseProps,
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next(true); }, () => { next('/'); });
    },
    component: () => import(/* webpackChunkName: "bundle.heroes" */ '../views/Customer.vue'),
  },
  {
    path: '/past-billings/:id',
    name: 'past-billing-detail',
    // props: true,
    props: parseProps,
    beforeEnter(to, from, next) {
      isUserAuthenticated().then(() => { next(true); }, () => { next('/'); });
    },
    component: () => import(/* webpackChunkName: "bundle.heroes" */ '../views/PastBilling.vue'),
  },
  {
    path: '/users',
    name: 'pool-users',
    beforeEnter(to, from, next) {
      isAdmin().then(() => { next(true); }, () => { next(false); });
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "billing-app" */ '../views/PoolUsers.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
